import React, {Component} from "react"
import AdNTV from '../ads/NTV'
import Link from '../links/RouterLink'
import Player from '../Player'
import {videoFetch} from "../../redux/actions"
import {connect} from "react-redux"
import withDeviceContext from '../WithDeviceContext'

class VideoWindow extends Component {

    constructor(props) {
        super(props);
        this.player = this.player.bind(this)
    }

    componentDidMount() {
        let {dispatch, video_id} = this.props
        dispatch(videoFetch(video_id))
    }

    models() {
        if (!this.props.video.models || !this.props.video.models.length) {
            return null;
        }
        let models = this.props.video.models.map((model) => {
            return <Link className="related-model" onclick={this.close} route="model" params={{slug: model.slug}}
                         text={model.title} key={model.id}>{model.title}</Link>
        });
        return <span>Models: {models}</span>
    }

    categories() {
        if (!this.props.video.categories || !this.props.video.categories.length) {
            return null;
        }
        let cats = this.props.video.categories.map((cat, i) => {
            return <Link className="related-category" onclick={this.close} route="category"
                         params={{cat_slug: cat.slug}} text={cat.title} key={i}>{cat.title}</Link>
        });
        return <span>Categories: {cats}</span>
    }

    player() {
        return (this.props.video.files || this.props.video.embed || this.props.video.playerEmbedUrl) ?
            <Player {...this.props.video} device={this.props.device} /> : null
    }


    render() {
        let AdNTVComponent = this.props.device === 'desktop' ? <AdNTV key={Math.random()}/> : null
        return (
            <React.Fragment>
                {this.props.video &&
                <div className="popup-content">
                    <h2 className="video-title">{this.props.video.title}</h2>
                    <div className="video-bg">
                        <div className="video-wrapper">
                            {this.player()}
                        </div>
                        {AdNTVComponent}
                    </div>
                    <div className="video-links">
                        {this.models()}
                        {this.categories()}
                        <span className="additional-data" onClick={() => window.location.reload()} ><a
                            href="#">Video info</a></span>
                    </div>
                </div>
                }
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => {
    return state.modal
}

export default connect(mapStateToProps)(withDeviceContext(VideoWindow))



// WEBPACK FOOTER //
// components/windows/VideoWindow.js